import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withApollo } from 'react-apollo';

import SubunitSummary from './SubunitSummary';
import SubunitResources from '../_shared/SubunitResources';
import './SubunitDetail.scss';

class SubunitDetail extends Component {
  static displayName = 'SubunitDetail';

  static propTypes = {
    userData: PropTypes.object,
    unitNumber: PropTypes.string,
    unitItem: PropTypes.object,
    subunit: PropTypes.object,
    params: PropTypes.object,
  };

  constructor(props) {
    super(props);

    const { params, unitItem, subunit } = props;
    this.subunitHighlighted =
      params.unitNumber === unitItem.number &&
      params.subunitNumber === subunit.number;
  }

  componentDidMount() {
    if (this.subunitHighlighted) {
      const node = ReactDOM.findDOMNode(this);
      const nodeRect = node.getBoundingClientRect();
      const middleWindow = window.innerHeight / 2;

      window.scrollTo(0, nodeRect.top - middleWindow);
    }
  }

  render() {
    const {
      userData: { isStudent },
      unitNumber,
      subunit,
      unitItem,
    } = this.props;
    const { resources, number: subunitNumber } = subunit;
    const { id: unitId, isShareable } = unitItem;

    /**
     * Set disabled action for resources if unit item is shareable
     * */

    return (
      <div className="subunit-detail">
        <SubunitSummary subunit={subunit} />
        <SubunitResources
          isStudent={isStudent}
          unitId={unitId}
          unitNumber={unitNumber}
          subunitNumber={subunitNumber}
          unitIsShareable={isShareable}
          resources={resources}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userData: state.userData,
  };
}

export default withApollo(withRouter(connect(mapStateToProps)(SubunitDetail)));
